var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7197 0.170013C17.9449 0.170013 18.9415 1.1667 18.9415 2.39181C18.9415 3.61691 17.9453 4.61353 16.7197 4.61353C15.4941 4.61353 14.4979 3.61691 14.4979 2.39181C14.4979 1.1667 15.4946 0.170013 16.7197 0.170013Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52892 0.170013C10.754 0.170013 11.7507 1.1667 11.7507 2.39181C11.7507 3.61691 10.754 4.61353 9.52892 4.61353C8.30375 4.61353 7.30692 3.61691 7.30692 2.39181C7.30692 1.1667 8.30334 0.170013 9.52892 0.170013Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2218 4.6136C0.9969 4.6136 4.76837e-06 3.61698 4.76837e-06 2.39188C4.76837e-06 1.16677 0.996075 0.170013 2.2218 0.170013C3.44752 0.170013 4.44359 1.1667 4.44359 2.39181C4.44359 3.61691 3.44676 4.6136 2.2218 4.6136Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7778 11.7329C15.5527 11.7329 14.5558 10.7365 14.5558 9.51118C14.5558 8.28581 15.5527 7.28918 16.7778 7.28918C18.0029 7.28918 19 8.28588 19 9.51118C19 10.7365 18.0029 11.7329 16.7778 11.7329Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.587 11.7329C8.3621 11.7329 7.3652 10.7365 7.3652 9.51118C7.3652 8.28581 8.36128 7.28918 9.587 7.28918C10.8125 7.28918 11.8088 8.28581 11.8088 9.51118C11.8088 10.7365 10.8121 11.7329 9.587 11.7329Z",
    fill: "#9E9E9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27924 11.7329C1.05386 11.7329 0.0574474 10.7365 0.0574474 9.51118C0.0574474 8.28581 1.05386 7.28918 2.27924 7.28918C3.50462 7.28918 4.50186 8.28581 4.50186 9.51118C4.50186 10.7365 3.50496 11.7329 2.27924 11.7329Z",
    fill: "#9E9E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.727 14.3864C17.9521 14.3864 18.9492 15.3828 18.9492 16.6082C18.9492 17.8331 17.9521 18.8299 16.727 18.8299C15.5018 18.8299 14.5052 17.8336 14.5052 16.6082C14.5052 15.3828 15.5018 14.3864 16.727 14.3864Z",
    fill: "#9E9E9E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53574 14.3864C10.7609 14.3864 11.7579 15.3828 11.7579 16.6082C11.7579 17.8331 10.7613 18.8299 9.53574 18.8299C8.31085 18.8299 7.31402 17.8336 7.31402 16.6082C7.31402 15.3828 8.31085 14.3864 9.53574 14.3864Z",
    fill: "#9E9E9E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22881 14.3864C3.45371 14.3864 4.45061 15.3828 4.45061 16.6082C4.45061 17.8331 3.45371 18.8299 2.22881 18.8299C1.00344 18.8299 0.00702 17.8336 0.00702 16.6082C0.00702 15.3828 1.00392 14.3864 2.22881 14.3864Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6e11a1b4163ac855d41e521882004d96.svg";
export { ForwardRef as ReactComponent };